module.exports = __webpack_public_path__ + "ptc_momoro_C2.fb636f08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_C2.jpg
// module id = 1Wm2
// module chunks = 0